<template>

<section v-if="format == 'text_grid' || format == 'horizontal_list'" v-bind="$attrs" class="category-feed py-5% px-4" :class="format">
    <div class="max-w-4xl mx-auto w-full" ref="trigger">
        <SmoothLoader tag="h2" v-if="headline" class="font-headline text-center text-3xl vt:text-4rem font-bold mb-8 vt:mb-10 text-primary-700 leading-tight" v-html="headline"></SmoothLoader>
        <SmoothLoader v-if="blurb" class="blurb prose text-lg text-gray-800 font-body max-w-xl mx-auto w-full mb-16" v-html="blurb">
        </SmoothLoader>
        <div class="grid gap-4" v-if="trigger">

            <!-- Text Grid -->
            <template v-if="format == 'text_grid'">
                <SmoothLoader :trigger="trigger" v-for="(post, i) in posts" :delay="(i * 100) + 200" class="grid-item">
                    <component :is="post.is_redirect ? 'a' : 'Link'" :href="post.link" class="block h-full relative bg-white rounded-xl px-8 pt-8 pb-12 vt:px-10 vt:pt-10 vt:pb-16" :target="post.is_redirect ? '_blank' : null">
                        <span class="title block transition-colors mb-4 text-lg font-headline font-bold text-primary-700" v-html="post.title"></span>
                        <div v-if="post.excerpt" class="blurb text-gray-800 transition-colors font-body" v-html="post.excerpt"></div>
                        <span class="corner text-primary-400 absolute">
                            <i class="fa-solid fa-circle-plus text-2xl" aria-hidden="true"></i>
                        </span>
                    </component>
                </SmoothLoader>
            </template>

            <!-- Horizontal List -->
            <template v-if="format == 'horizontal_list'">
                <SmoothLoader v-for="(post, i) in posts" class="grid-item">
                    <component :is="post.is_redirect ? 'a' : 'Link'" :href="post.link" class="block h-full relative bg-white rounded-xl p-8" :target="post.is_redirect ? '_blank' : null">
                        <div class="flex flex-wrap">
                            <div v-if="post.thumbnail" class="thumbnail-container vt:mr-8">
                                <img :src="post.thumbnail.src" :alt="post.thumbnail.alt" class="rounded-md">
                            </div>
                            <div class="w-full vt:flex-1" :class="{'vt:pt-8': post.thumbnail}">
                                <span class="title block transition-colors mb-4 text-lg font-headline font-bold text-primary-700" v-html="post.title"></span>
                                <div v-if="post.excerpt" class="blurb text-gray-800 transition-colors font-body" v-html="post.excerpt"></div>
                                <span class="corner text-primary-400 absolute">
                                    <i class="fa-solid fa-circle-plus text-2xl" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                    </component>
                </SmoothLoader>
            </template>

        </div>
        <SmoothLoader class="flex justify-center mt-12">
            <Button variant="button-2" :href="category_link" label="View All"></Button>
        </SmoothLoader>
    </div>
</section>

<!-- Blue Breakout -->
<section v-if="format == 'blue_breakout'" v-bind="$attrs" class="category-feed blue_breakout bg-primary-400 py-7% px-4">
    <div class="max-w-4xl mx-auto" ref="trigger">
        <SmoothLoader tag="h2" v-if="headline" class="font-headline text-center text-3xl vt:text-4rem font-bold mb-8 vt:mb-10 text-primary-700 leading-tight" v-html="headline"></SmoothLoader>
        <div v-if="blurb" class="blurb prose text-lg text-primary-800 font-body max-w-xl mx-auto w-full mb-16" v-html="blurb">
        </div>
        <div class="grid gap-4" v-if="trigger">
            <SmoothLoader :trigger="trigger" v-for="(post, i) in posts" :delay="(i * 100) + 200" class="grid-item">
                <component :is="post.is_redirect ? 'a' : 'Link'" :href="post.link" class="block h-full relative bg-white rounded-xl px-8 py-16" :target="post.is_redirect ? '_blank' : null">
                    
                    <time class="absolute text-primary-800 transition-colors uppercase font-headline font-bold text-sm">{{ post.date }}</time>

                    <span class="kicker mb-2 block text-lg transition-colors text-primary-500 uppercase font-bold font-headline" v-if="post.kicker" v-html="post.kicker"></span>
                    <span class="title block transition-colors mb-4 text-lg font-headline font-bold text-primary-700" v-html="post.title"></span>
                    <div v-if="post.excerpt" class="blurb text-gray-800 transition-colors font-body" v-html="post.excerpt"></div>
                    <span class="corner text-primary-400 absolute">
                        <i class="fa-solid fa-chevrons-right text-2xl" aria-hidden="true"></i>
                    </span>
                </component>
            </SmoothLoader>
        </div>
        <SmoothLoader class="flex justify-center mt-12">
            <Button variant="button-4" :href="category_link" label="View All"></Button>
        </SmoothLoader>
    </div>
</section>

<!-- Video Feed -->
<section v-if="format == 'video_feed'" v-bind="$attrs" class="category-feed video_feed bg-primary-400 py-7% px-4">
    <div class="max-w-4xl mx-auto" ref="trigger">
        <SmoothLoader tag="h2" v-if="headline" class="font-headline text-center text-3xl vt:text-4rem font-bold mb-8 vt:mb-10 text-primary-700 leading-tight" v-html="headline"></SmoothLoader>
        <SmoothLoader v-if="blurb.length" class="blurb prose text-lg text-primary-800 font-body max-w-xl mx-auto w-full mb-16" v-html="blurb">
        </SmoothLoader>
        <div class="grid gap-4">
            <SmoothLoader :trigger="trigger" v-for="(post, i) in posts" :delay="(i * 100) + 200" class="grid-item">
                <VideoModal :youtube-id="post.video_id" class="block h-full w-full relative rounded-xl overflow-hidden appearance-none bg-primary-800 icon-expands bg-expands">
                    <BackgroundImage v-if="post.thumbnail" :src="post.thumbnail.src" :alt="post.thumbnail.alt" opacity="0.45"></BackgroundImage>
                    <div class="absolute w-full h-full left-0 top-0 z-10 flex items-center justify-center">
                        <span :class="i === 0 ? 'vt:text-2xl' : ''" class="title absolute transition-colors mb-4 font-headline font-bold text-gray-500" aria-hidden="true" v-html="post.title"></span>
                        <span class="play-icon text-gray-500">
                            <i class="fa-solid fa-circle-play text-6xl" aria-hidden="true"></i>
                            <span class="sr-only" v-html='`Play our video "${post.title}"`'></span>
                        </span>
                    </div>
                </VideoModal>
            </SmoothLoader>
        </div>
        <SmoothLoader class="flex justify-center mt-12">
            <Button variant="button-4" :href="category_link" label="View All"></Button>
        </SmoothLoader>
    </div>
</section>

</template>

<script>

import VideoModal from '../Utilities/VideoModal.vue';
import { ref } from 'vue';

export default {

    props: ['data'],
    
    setup(props) {

        const trigger = ref(null);

        return {
            trigger,
            ...props.data
        }
    },

    components: {
        VideoModal
    }



}
</script>